export class SourceAccountsFilterConditions {
    'id';
    'providerAccountId';
    'accountStatus';
    'cloudProvider';
    'accountName';
    'providerParentId';
    'parentId';
    'freeText';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "ProviderAccountIdFilters",
            "format": ""
        },
        {
            "name": "accountStatus",
            "baseName": "accountStatus",
            "type": "AccountStatusFilters",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderFilters",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "AccountNameFilters",
            "format": ""
        },
        {
            "name": "providerParentId",
            "baseName": "providerParentId",
            "type": "ProviderParentIdFilters",
            "format": ""
        },
        {
            "name": "parentId",
            "baseName": "parentId",
            "type": "ParentIdFilters",
            "format": ""
        },
        {
            "name": "freeText",
            "baseName": "freeText",
            "type": "FreeTextFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
